import { useMutation } from 'react-query'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'

interface RequestIntegrationBody {
  integrationName: string
  role: 'source' | 'destination'
  description: string
}

interface RequestIntegrationResponse {
  status: 'new' | 'waiting_list' | 'existing'
  message?: string
  appName?: string
}

const requestIntegration = async (
  body: RequestIntegrationBody
): Promise<{ data: RequestIntegrationResponse }> => {
  const response = await apiAuthClient.post<{
    data: RequestIntegrationResponse
  }>(endpoints.requestIntegration, body)
  return { data: response.data.data }
}

export const useRequestIntegration = () => {
  return useMutation(requestIntegration)
}
